import { FloraAIIcon } from '@practium/ui';
import styles from './FloraFillAnimation.module.css';

interface FloraFillAnimationProps {
	isAnimating: boolean;
}

export const FloraFillAnimation = ({ isAnimating }: FloraFillAnimationProps) => {
	if (!isAnimating) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.ellipseBlue} />
			<div className={styles.ellipsePurple} />
			<div className={styles.floraGlow}>
				<FloraAIIcon className={styles.floraIcon} />
			</div>
		</div>
	);
};
